export default __webpack_public_path__ + "static/media/info-solid.7cd33e4d.svg";